
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './elections.json';

const Elections = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Political vocabulary, voting systems, and democracy discussions. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Elections"
            image="/Images/voting1.webp"
            seoTitle="Free English Lesson Plans: Elections"
            seoDescription="Political vocabulary, voting systems, and democracy discussions. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Elections;


